import(/* webpackMode: "eager" */ "/builds/client-projects/bazaar/bazaar-web-app/site/src/app/profile/[id]/profile.tsx");
import(/* webpackMode: "eager" */ "/builds/client-projects/bazaar/bazaar-web-app/site/src/lib/page-view-tracker.tsx")